import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers} from "@angular/http";
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';
import {CompleterItem} from "ng2-completer";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {CourseM} from "../model/course.model";
import {Util} from "../util/util";

@Injectable()
export class CoursesService {

  private messageSource = new BehaviorSubject<string>("default message");
  searchObj: CompleterItem = null;
  private searchCourseItem = new Subject<CompleterItem>();

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAllCourses(searchStr: string = "", status: string = "", offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/course/getList?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getList(searchStr: string, status: string, approved: boolean, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/course/getListByAdmin?searchStr=${searchStr}&status=${status}&approved=${approved}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getAllCoursesOfUser(searchStr: string = "", status: string = "", offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/course/getListOfUser?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getAllCourseRequests(searchStr: string = "", status: string = "", offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/course_request/getList?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getAllCourseRequestsOfUser(searchStr: string = "", status: string = "", offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/course_request/getListOfUser?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getCourseStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/course/getStatusCount`, this.options).map(res => res.json());
  }

  getCourseRequestsStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/course_request/getStatusCount`, this.options).map(res => res.json());
  }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  setCourseSelectedFromHeaderSearch(item: CompleterItem) {
    this.searchCourseItem.next(item);
  }

  getCourseHeaderSearchItem(): Observable<any> {
    this.reloadToken()
    return this.searchCourseItem.asObservable();
  }

  getDetail(courseNo: string) {
    this.reloadToken()
    return this.http.get(`/api/course/${courseNo}`, this.options).map(res => res.json());
  }

  createCourse(course: CourseM) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    let options = new RequestOptions({headers: headers});

    this.reloadToken()
    return this.http.post(`/api/course_teacher/`, course, options).map(res => res.json());
  }

  updateCourse(course: CourseM) {
    this.reloadToken()
    return this.http.put(`/api/course_teacher/`, course, this.options).map(res => res.json());
  }


  approveCourse(course: CourseM) {
    this.reloadToken()
    return this.http.put(`/api/course/approve/${course.id}`, course, this.options).map(res => res.json());
  }

  trashCourse(course: CourseM) {
    this.reloadToken()
    return this.http.delete(`/api/course_teacher/${course.id}`, this.options).map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/courses.service.ts